<template>
  <v-form ref="frmEpicMain" @submit="save" onSubmit="return false;" v-model="valid" lazy-validation class="form-inputs">
    <v-card :loading="loading" :disabled="loading">
      <v-card-title> Add an Epic to {{ project.Name }} </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <TextField :rules="[rules.required, exist()]" placeholder="Epic" label="Epic" v-model="epic" outlined />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-col cols="12" md="12">
          <v-btn color="secondary" class="right" @click="save"><v-icon>mdi-check</v-icon>Add</v-btn>
          <v-btn text color="primary" class="right mr-5" @click="cancel">cancel</v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script lang="ts">
import { ProjectMessages } from "../../definitions/constants";
import Vue, { defineComponent } from "vue";
import TextField from "../../components/Fields/TextField.vue";

export default defineComponent({
  props: ["project", "epicLoading", "epicList"],
  data() {
    return {
      valid: false,
      epic: "",
      loading: false,
      rules: {
        required: (value:any) => !!value || "Required.",
      },
    };
  },
  components: {
    TextField,
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    exist(){
      if (this.epic) {
        var exist = this.epicList.some((c:any) => c && c.toLowerCase().trim() === this.epic.toLowerCase().trim())
        if (exist) {
          return ProjectMessages.existItem;
        }
      }
      return true;
    },
    async save() {
      const isValid = (await (this.$refs.frmEpicMain as any).validate()).valid;
      if (isValid) {
        this.loading = true;
        this.$emit("success", { epic: this.epic, projectId: this.project.id });
      }
    },
  },
  watch: {
    epicLoading(newVal) {
      this.loading = newVal;
    },
  },
});
</script>
